import { Empty, List } from 'antd';
import { forwardRef, useEffect, useState } from 'react';
import NewsLetter from './NewsLetter';
import { getNewsLetters } from './getNewsLetters';

type NewsLettersListProps = {
  t: (key: string) => string;
};

const list: { name: string; summary: string }[] = [
  {
    name: 'June Biweekly report',
    summary: 'lorem ipsium',
  },
  {
    name: 'June Biweekly report2',
    summary: 'lorem ipsium',
  },
  {
    name: 'June Biweekly report',
    summary: 'lorem ipsium',
  },
  {
    name: 'June Biweekly report',
    summary: 'lorem ipsium',
  },
  {
    name: 'June Biweekly report5',
    summary: 'lorem ipsium',
  },
  {
    name: 'June Biweekly report',
    summary: 'lorem ipsium',
  },
];
const NewsLettersList = forwardRef<HTMLDivElement, NewsLettersListProps>(({ t }, ref) => {
  const [newsLetters, setNewsLetters] = useState<any[]>([]);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [total, setTotal] = useState<number>(0);

  const pageLimit = 3;
  const getNewsLettersWrapper = async (page: number) => {
    try {
      const res = await getNewsLetters(page, pageLimit, 'true');

      if (res.statusText === 'SUCCESS') {
        setNewsLetters(res.data.data);
        setTotal(res.data.total);
      }
    } catch (error: any) {
      throw error;
    }
  };

  useEffect(() => {
    getNewsLettersWrapper(currentPage);
  }, []);

  const handlePageChange = (page: number, _pageSize: number) => {
    setCurrentPage(page);
    getNewsLettersWrapper(page);
  };

  return (
    <div className="section mx-10" ref={ref}>
      <h1 className="section-title">{t('ReportsSectionTitle')}</h1>
      <div className="reports flex flex-col gap-5">
        {newsLetters?.length > 0 ? (
          <List
            itemLayout="horizontal"
            dataSource={newsLetters}
            split={false}
            // locale={{emptyText: t('noNewslettersAvailable')}}
            pagination={{
              position: 'bottom',
              align: 'start',
              pageSize: 3,
              current: currentPage,
              onChange: handlePageChange,
              total: total,
              // showSizeChanger: true,
              // showQuickJumper: true,
              // pageSizeOptions: ['2', '5', '10'],
              // showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} tasks`,
              // onShowSizeChange: handlePageChange,
            }}
            renderItem={(item, index) => (
              <List.Item>
                <NewsLetter id={item.id} name={item.title} summary={item.summary} t={t} />
              </List.Item>
            )}
          />
        ) : (
          <Empty description={t('noNewslettersAvailable')} image={Empty.PRESENTED_IMAGE_SIMPLE} />
        )}
      </div>
    </div>
  );
});

export default NewsLettersList;
